var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex",class:{ toggled: _vm.isSidebar },attrs:{"id":"wrapper"}},[_c('app-sidebar'),_c('div',{staticStyle:{"width":"100%"},attrs:{"id":"page-content-wrapper"}},[_c('i',{staticClass:"material-icons",staticStyle:{"cursor":"pointer"},attrs:{"id":"menu-toggle"},on:{"click":function($event){_vm.isSidebar = !_vm.isSidebar}}},[_vm._v("view_headline")]),_c('app-navbar'),_c('div',{staticClass:"container-fluid mt-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('vs-breadcrumb',{attrs:{"align":"left","items":[
                  {title: 'You are here : '},
                  {
                    title: 'Reports',
                    
                  },
                  {
                    title: 'Strategic Report',
                    
                    active: true
                  }
                ]}})],1)]),_c('StrategicReport')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }